import {
	Button,
	IconBlock,
	IconLockOpen,
} from '@montel/montelpro-shared-components-v2';
import { ConditionallyDisabled } from 'components/common/ConditionallyDisabled/ConditionallyDisabled';
import { ButtonContainer } from 'components/common/Product/Cells/styles';
import { MontelAccount } from 'domain/account/interfaces';
import useAuthRoles from 'hooks/useAuthRoles';
import { Dispatch, FunctionComponent, SetStateAction } from 'react';

interface BlockActionCellProps {
	account: MontelAccount;
	onSuccess: (account: MontelAccount) => void;
	setShowBlockAccountModal: Dispatch<SetStateAction<boolean>>;
	setShowReopenAccountModal: Dispatch<SetStateAction<boolean>>;
}

export const BlockActionsCell: FunctionComponent<BlockActionCellProps> = ({
	account,
	onSuccess,
	setShowBlockAccountModal,
	setShowReopenAccountModal,
}) => {
	const { isSuperAdmin, isMontelAccountAdmin } = useAuthRoles();
	const canApproveOrDeny = isSuperAdmin || isMontelAccountAdmin;

	return (
		<ButtonContainer>
			<ConditionallyDisabled
				disableIf={!canApproveOrDeny}
				tooltip="You do not have permission to perform this action."
			>
				<Button
					size="sm"
					text={account.locked ? 'Reopen' : 'Block'}
					type="button"
					variant={account.locked ? 'primary' : 'negative'}
					leftIcon={account.locked ? <IconLockOpen /> : <IconBlock />}
					onClick={(e) => {
						e.stopPropagation();
						onSuccess(account);

						account.locked
							? setShowReopenAccountModal(true)
							: setShowBlockAccountModal(true);
					}}
				/>
			</ConditionallyDisabled>
		</ButtonContainer>
	);
};
